module.exports = __webpack_public_path__ + "static/media/logo-ucs.c0914c23.svg";